"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_SIZES = void 0;
exports.MEDIA_SIZES = {
    SEARCH_PAGE: '370x155',
    SINGLE_PROPERTY_PAGE: '732x584',
};
